import {styled} from '../../design-system'

export const LineupItem = styled.span`
  display: inline;

  margin-right: 0.25em;
  font-weight: 500;

  :not(:first-child) {
    ::before {
      content: '|';
      margin-right: 0.25em;
      color: rgba(255, 255, 255, 0.25);
    }
  }
`
